import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Facebook, Instagram, Youtube } from "lucide-react";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3>About Us</h3>
            <p className="about-text">
              We take pride in customer care and our repeat customers are a testament to the excellent service that we provide.
            </p>

            <button className="read-more-btn" onClick={() => navigate("/about")}>
              Read More
            </button>

            <div className="social-icon">
              <div className="facebook-icon">
                <Facebook size={16} />
              </div>
              <div className="instagram-icon">
                <Instagram size={16} />
              </div>
              <div className="youtube-icon">
                <Youtube size={16} />
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">
                  <span className="bullet-point">⊞</span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about">
                  <span className="bullet-point">⊞</span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  <span className="bullet-point">⊞</span>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <ul className="footer-links">
              <li>
                <Link to="/ecu-remapping">
                  <span className="bullet-point">⊞</span>
                  Ecu Remapping
                </Link>
              </li>
              <li>
                <Link to="/programming">
                  <span className="bullet-point">⊞</span>
                  Programming & Coding
                </Link>
              </li>
              <li>
                <Link to="/diagnostic">
                  <span className="bullet-point">⊞</span>
                  Diagnostic
                </Link>
              </li>
              <li>
                <Link to="/car-service">
                  <span className="bullet-point">⊞</span>
                  Car Service
                </Link>
              </li>
              <li>
                <Link to="/recovery">
                  <span className="bullet-point">⊞</span>
                  Recovery Services
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>

            <div className="contact-info">
              <div className="contact-label">PHONE:</div>
              <div className="contact-value">
                <a href="tel:+447501911970">+44 7501 911970</a>
              </div>
            </div>

            <div className="contact-info">
              <div className="contact-label">EMAIL:</div>
              <div className="contact-value">
                <a href="mailto:carforensicsltd@gmail.com">carforensicsltd@gmail.com</a>
              </div>
            </div>
          </div>
        </div>

        <div className="copyright-section">
          <p className="copyright-text">© 2025 Car Forensics Ltd. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
